export const environment = {
  production: true,
  hmr: false,
  sessionTimeoutSec: 1800
};
